/**
 * Brand constants shared by live chrome and the marketing pages.
 *
 * The strapline previously lived in four places - Header, Footer, the
 * organisation schema and the solution constants - because earlier revisions of
 * this branch deliberately avoided touching the live shared components. That is
 * no longer true, so it is centralised here before the copies drift.
 */

export const STRAPLINE = "Giving you time to think differently";

/** The single address for marketing and sales enquiries. */
export const ENQUIRY_EMAIL = "hello@larasoft.global";

/** Display format for humans. `WHATSAPP_NUMBER` in enquiry.ts is the dialable one. */
export const TELEPHONE_DISPLAY = "+27 82 457 8390";

/** E.164, for structured data and `tel:` links. */
export const TELEPHONE_E164 = "+27824578390";

/** Larasoft's Google Business Profile review link. */
export const GOOGLE_REVIEW_URL = "https://g.page/r/CRIZ7Nbqk1YKEBM/review";
